<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="legal" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content">
      <h1>Disclaimer</h1>
      <p>The information provided on GB Wave is for informational purposes only.</p>
      <p>
        GB Wave is an independent website that provides guides, news, and information about GB WhatsApp and related Android applications.
      </p>

      <h2>Third-Party Applications</h2>
      <p>
        GB WhatsApp is a modified application developed by third-party developers. GB Wave does not create, own, or manage GB WhatsApp.
      </p>
      <p>
        We are not affiliated with WhatsApp LLC, Meta Platforms, Inc., or any official WhatsApp service.
      </p>

      <h2>Accuracy of Information</h2>
      <p>
        We make every effort to provide accurate and updated information. However, application features, compatibility, and availability may change without notice.
      </p>

      <h2>User Responsibility</h2>
      <p>
        Users should carefully evaluate applications before installation and use. GB Wave is not responsible for any issues caused by third-party applications.
      </p>

      <h2>Trademark Notice</h2>
      <p>WhatsApp and related trademarks belong to their respective owners.</p>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';

export default {
  name: 'DisclaimerPage',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Disclaimer', current: true },
      ],
    };
  },
};
</script>
